import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

// "You wrote yourself a letter for this" prompt for hard moments
export const OpenWhenNudge = ({ dark = false }) => {
  const [l, setL] = useState(null);
  useEffect(() => { if (navigator.onLine) api.get("/open-when/suggest").then((r) => setL(r.data.letter)).catch((e) => logError("Open-when suggest failed:", e)); }, []);
  if (!l) return null;
  return (
    <Link to={`/letters?ow=${l.id}`} className={`block rounded-3xl p-4 text-left mm-fade-up ${dark ? "bg-white/10 text-white" : "bg-[#FCE8EE] text-[#3A2E4F]"}`} data-testid="open-when-nudge">
      <div className="font-semibold">💌 You wrote yourself a letter for this</div>
      <div className={`text-sm mt-1 ${dark ? "text-white/70" : "opacity-70"}`}>Open when… {l.topic}</div>
    </Link>
  );
};
